import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCitiesListAction,
  getProvincesListAction,
  getRegionsListAction,
} from "../actions/search.action";

export const usePlacesData = () => {
  const dispatch = useDispatch();

  const citiesList = useSelector((state) => state.search.places.cities);
  const regionsList = useSelector((state) => state.search.places.regions);
  const provincesList = useSelector((state) => state.search.places.provinces);

  const loadPlaces = useCallback(() => {
    if (citiesList.length === 0)
      dispatch(getCitiesListAction({ type: "cities" }));
    if (regionsList.length === 0)
      dispatch(getRegionsListAction({ type: "regions" }));
    if (provincesList.length === 0)
      dispatch(getProvincesListAction({ type: "provinces" }));
  }, [citiesList, regionsList, provincesList, dispatch]);

  return {
    citiesList,
    regionsList,
    provincesList,
    loadPlaces,
  };
};

export default usePlacesData;
